export default __webpack_public_path__ + "static/Rolvedon_final_fullsize-10b-354ac154d88aecb93a6597c095a7387b.png";